// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { BsBoxSeam } from "react-icons/bs"; // Added icon import
// import { DeleteSponsorApi, FetchSponsor } from "../../ApiCalls/AddProducts";
// import DeleteModal from "../../components/DeleteModal/DeleteModal";
// import { toast, ToastContainer } from "react-toastify";
// import { USER_URL } from "../../constant/api";
// import { useAuth } from "../../context/AuthContext";

// const SellerSponsored = () => {
//   const [sponsor, setSponsor] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [selectedSponsor, setSelectedSponsor] = useState(null);
//   const { user } = useAuth();
//   // Fetch sponsors on component mount
//   const fetchSponsors = async () => {
//     setLoading(true);
//     try {
//       const response = await FetchSponsor();
//       setSponsor(response.Data || []); // Default to an empty array if response is undefined
//     } catch (error) {
//       console.error("Failed to fetch sponsors:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSponsors();
//   }, []);
//   const handleDelete = async () => {
//     if (selectedSponsor) {
//       try {
//         console.log(selectedSponsor);

//         await DeleteSponsorApi(selectedSponsor);
//         // setProducts(products.filter((p) => p.id !== selectedProduct.id));

//         setShowConfirm(false);
//         setSelectedSponsor(null);
//         setSponsor(sponsor.filter((s) => s.id !== selectedSponsor));
//         toast.success("Sponsor Deleted successfully!");
//       } catch (error) {
//         console.error("Error deleting product:", error.message || error);
//         setShowConfirm(false);
//         toast.error("Error deleting Sponsor!");
//       }
//     }
//   };

//   const payNow = async (id) => {
//     try {
//       const data = {
//         payment_for: "sponsored", // sponsored, banner, special_offer
//         object_id: id,
//       };
//       console.log("Payment Data:", data);

//       const res = await USER_URL.post(
//         "/orders/seller/promotion/razorpay/initiate/",
//         data,
//       );
//       const { razorpay_order_id, amount } = res.data.payment;
//       const { razorpay_key } = res.data;
//       const customerOrderNumber = res.data.customer_order_number;
//       // console.log(" Razorpay Order ID:", customerOrderNumber);

//       console.log(" INIT RESPONSE", res.data);

//       const options = {
//         key: razorpay_key,
//         currency: "INR",
//         amount: amount,
//         order_id: razorpay_order_id,
//         name: "BricksnMix",
//         description: "Service Payment",
//         image: "/images/logo/icon_sg.png",
//         handler: async function (response) {
//           console.log("Payment Response:", response);
//           const confirmData = {
//             razorpay_order_id: response.razorpay_order_id,
//             razorpay_payment_id: response.razorpay_payment_id,
//             razorpay_signature: response.razorpay_signature,
//             // customer_order_number: customerOrderNumber,
//           };
//           console.log("💳 Payment Confirmation Data:", confirmData);

//           const verify = await USER_URL.patch(
//             "/orders/seller/promotion/razorpay/confirm/",
//             confirmData,
//           );
//           console.log(" Payment Verification:", verify.data);
//           if (verify.data.Status === "1") {
//             toast.success("Payment Successful");
//             fetchSponsors();
//           } else {
//             toast.error("Payment Failed");
//           }
//         },
//         prefill: {
//           name: user?.user_name || "User name",
//           email: user?.email || "user@gmail.com",
//           contact: "9999999999",
//         },
//         theme: {
//           color: "#F37254",
//         },
//         modal: {
//           ondismiss: function () {
//             console.log(" Razorpay popup closed");
//           },
//         },
//       };

//       const razorpay = new window.Razorpay(options);
//       razorpay.open();
//     } catch (err) {
//       console.error(" Error in payNow:", err);
//     }
//   };

//   return (
//     <div className="container mx-auto px-4">
//       <div className="mr-5 mt-5 flex items-center justify-end">
//         <Link
//           to="/seller/offer_brand/sponsor/Add"
//           className="rounded-lg bg-green-600 px-6 py-2 font-medium text-white shadow hover:bg-green-700"
//         >
//           + Add New Sponsor
//         </Link>
//       </div>
//       {/* Table Section */}
//       <div className="overflow-x-auto">
//         {loading ? (
//           // Show loading spinner
//           <div className="flex h-40 items-center justify-center">
//             <div className="spinner-border inline-block h-8 w-8 animate-spin rounded-full border-4 text-brand-primary"></div>
//             <p className="ml-2">Loading Sponsor...</p>
//           </div>
//         ) : sponsor.length === 0 ? (
//           // Show no offers message
//           <div className="mt-10 text-center">
//             <BsBoxSeam className="mx-auto mb-4 text-6xl text-gray-400" />
//             <p className="text-lg text-gray-600">
//               No sponsored products available
//             </p>
//           </div>
//         ) : (
//           <>
//             {/* Table Header */}
//             <div className="mt-10 w-full space-y-4">
//               <div className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
//                 <div className="text-center">Item No</div>
//                 <div className="text-center">Title</div>
//                 <div className="text-center">Start Date</div>
//                 <div className="text-center">End Date</div>
//                 <div className="text-center">Edit</div>
//                 <div className="text-center">Delete</div>
//                 <div className="text-center">View</div>
//               </div>
//             </div>

//             {/* Table Body */}
//             {sponsor.map((s, index) => (
//               <div
//                 key={s.id}
//                 className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2 text-[#2F2E41]"
//               >
//                 <div className="rounded-xl border p-2 text-center">
//                   {index + 1}
//                 </div>
//                 <div className="rounded-xl border p-2 text-center">
//                   {s.title}
//                 </div>
//                 <div className="rounded-xl border p-2 text-center">
//                   {new Date(s.start_date).toLocaleDateString("en-GB")}
//                 </div>
//                 <div className="rounded-xl border p-2 text-center">
//                   {new Date(s.end_date).toLocaleDateString("en-GB")}
//                 </div>
//                 <div>
//                   {/* Pay Button */}
//                   <button
//                     onClick={() => payNow(s.id)}
//                     disabled={s.payment_status !== "Pending"}
//                     className={`flex flex-1 items-center justify-center rounded-lg px-2 py-2 text-center text-xs font-medium shadow-md transition sm:text-sm ${
//                       s.payment_status === "Pending"
//                         ? "border border-yellow-600 text-yellow-600 hover:border-yellow-700 hover:bg-yellow-700 hover:text-white"
//                         : s.payment_status === "Completed"
//                           ? "cursor-not-allowed border border-gray-400 bg-gray-100 text-gray-500"
//                           : s.payment_status === "Failed"
//                             ? "cursor-not-allowed border border-red-400 bg-red-100 text-red-500"
//                             : "border border-gray-300 bg-gray-100 text-gray-500"
//                     } `}
//                   >
//                     {s.payment_status === "Pending"
//                       ? "Pay"
//                       : s.payment_status === "Completed"
//                         ? "Paid"
//                         : s.payment_status === "Failed"
//                           ? "Failed"
//                           : "Unknown"}
//                   </button>
//                 </div>
//                 <Link to={`/seller/offer_brand/sponsor/Edit/${s.id}`}>
//                   <div className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-blue-600 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm">
//                     Edit
//                   </div>
//                 </Link>
//                 <div
//                   onClick={() => {
//                     setSelectedSponsor(s.id);
//                     setShowConfirm(true);
//                   }}
//                   className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-red-600 py-2 text-center text-xs font-medium text-red-600 shadow-md transition hover:border-red-700 hover:bg-red-700 hover:text-white sm:text-sm"
//                 >
//                   Delete
//                 </div>
//                 <Link to={`/seller/offer_brand/sponsor/View/${s.id}`}>
//                   <div className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-green-600 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm">
//                     View
//                   </div>
//                 </Link>
//               </div>
//             ))}
//           </>
//         )}
//       </div>
//       {/* Delete Confirmation Modal */}
//       {showConfirm && (
//         <DeleteModal
//           entityName="Sponsor"
//           title={selectedSponsor.title}
//           onConfirm={handleDelete}
//           onCancel={() => setShowConfirm(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default SellerSponsored;




import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsBoxSeam } from "react-icons/bs"; // Added icon import
import { DeleteSponsorApi, FetchSponsor } from "../../ApiCalls/AddProducts";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast, ToastContainer } from "react-toastify";
import { USER_URL } from "../../constant/api";
import { useAuth } from "../../context/AuthContext";
import ScaleLoader from "react-spinners/ScaleLoader";

const SellerSponsored = () => {
  const [sponsor, setSponsor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const { user } = useAuth();
  // Fetch sponsors on component mount
  const fetchSponsors = async () => {
    setLoading(true);
    try {
      const response = await FetchSponsor();
      setSponsor(response.Data || []); // Default to an empty array if response is undefined
    } catch (error) {
      console.error("Failed to fetch sponsors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSponsors();
  }, []);
  const handleDelete = async () => {
    if (selectedSponsor) {
      try {
        console.log(selectedSponsor);

        await DeleteSponsorApi(selectedSponsor);
        // setProducts(products.filter((p) => p.id !== selectedProduct.id));

        setShowConfirm(false);
        setSelectedSponsor(null);
        setSponsor(sponsor.filter((s) => s.id !== selectedSponsor));
        toast.success("Sponsor Deleted successfully!");
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
        setShowConfirm(false);
        toast.error("Error deleting Sponsor!");
      }
    }
  };

  const payNow = async (id) => {
    try {
      const data = {
        payment_for: "sponsored", // sponsored, banner, special_offer
        object_id: id,
      };
      console.log("Payment Data:", data);

      const res = await USER_URL.post(
        "/orders/seller/promotion/razorpay/initiate/",
        data,
      );
      const { razorpay_order_id, amount } = res.data.payment;
      const { razorpay_key } = res.data;
      const customerOrderNumber = res.data.customer_order_number;
      // console.log(" Razorpay Order ID:", customerOrderNumber);

      console.log(" INIT RESPONSE", res.data);

      const options = {
        key: razorpay_key,
        currency: "INR",
        amount: amount,
        order_id: razorpay_order_id,
        name: "BricksnMix",
        description: "Service Payment",
        image: "/images/logo/icon_sg.png",
        handler: async function (response) {
          console.log("Payment Response:", response);
          const confirmData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            // customer_order_number: customerOrderNumber,
          };
          console.log("💳 Payment Confirmation Data:", confirmData);

          const verify = await USER_URL.patch(
            "/orders/seller/promotion/razorpay/confirm/",
            confirmData,
          );
          console.log(" Payment Verification:", verify.data);
          if (verify.data.Status === "1") {
            toast.success("Payment Successful");
            fetchSponsors();
          } else {
            toast.error("Payment Failed");
          }
        },
        prefill: {
          name: user?.user_name || "User name",
          email: user?.email || "user@gmail.com",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          ondismiss: function () {
            console.log(" Razorpay popup closed");
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error(" Error in payNow:", err);
    }
  };

  return (
    <div className="container mx-auto px-4">
      <div className="mr-5 mt-5 flex items-center justify-end">
        <Link
          to="/seller/offer_brand/sponsor/Add"
          className="rounded-lg bg-green-600 px-6 py-2 font-medium text-white shadow hover:bg-green-700"
        >
          + Add New Sponsor
        </Link>
      </div>
      {/* Table Section */}
      <div className="overflow-x-auto">
        {/* Loading Spinner */}
        {loading ? (
          <div className="flex h-64 items-center justify-center">
            <ScaleLoader color="#FFAE00" height={40} />
          </div>
        ) : (
          <div className="mt-4 overflow-auto">
            <table className="min-w-full text-center">
              <thead>
                <tr>
                  <th className="text-md py-2 font-bold text-green-500">
                    Item No
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Banner Name
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Start Date
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Status
                  </th>
                  {/* <th className="px-2 py-2 text-green-500 text-md font-bold">Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {sponsor.length > 0 ? (
                  sponsor.map((product, index) => (
                    <tr key={product.id}>
                      <td className="px-3 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 py-2 text-gray-800">
                          {index + 1}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                          {product.title || "Name"}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-xl border p-2 text-center">
                          {new Date(product.start_date).toLocaleDateString(
                            "en-GB",
                          )}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                          {product.status || "P"}
                        </div>
                      </td>

                      {/* Action Buttons Row */}
                      <td className="px-4 py-3 text-sm">
                        <div className="flex gap-5">
                          {/* Pay Button */}
                          <button
                              onClick={() => payNow(product.id)}
                            disabled={product.payment_status !== "Pending"}
                            className={`flex flex-1 items-center justify-center rounded-lg px-2 py-2 text-center text-xs font-medium shadow-md transition sm:text-sm ${
                              product.payment_status === "Pending"
                                ? "border border-yellow-600 text-yellow-600 hover:border-yellow-700 hover:bg-yellow-700 hover:text-white"
                                : product.payment_status === "Completed"
                                  ? "cursor-not-allowed border border-gray-400 bg-gray-100 text-gray-500"
                                  : product.payment_status === "Failed"
                                    ? "cursor-not-allowed border border-red-400 bg-red-100 text-red-500"
                                    : "border border-gray-300 bg-gray-100 text-gray-500"
                            } `}
                          >
                            {product.payment_status === "Pending"
                              ? "Pay"
                              : product.payment_status === "Completed"
                                ? "Paid"
                                : product.payment_status === "Failed"
                                  ? "Failed"
                                  : "Unknown"}
                          </button>
                          {/* Edit Button */}
                          <Link
                            to={`/seller/offer_brand/Offer/Edit/${product.id}`}
                            className="flex flex-1 items-center justify-center rounded-lg border border-blue-600 px-2 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm"
                          >
                            Edit
                          </Link>

                          {/* View Button */}
                          <Link
                            to={`/seller/offer_brand/Offer/view/${product.id}`}
                            className="flex flex-1 items-center justify-center rounded-lg border border-green-600 px-2 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm"
                          >
                            View
                          </Link>
                          {/* Delete Button */}
                          <button
                            className="flex flex-1 items-center justify-center rounded-lg border border-red-600 px-2 py-2 text-center text-xs font-medium text-red-600 shadow-md transition hover:border-red-700 hover:bg-red-700 hover:text-white sm:text-sm"
                            onClick={() => {
                              setSelectedSponsor(product.id);
                              setShowConfirm(true);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="py-4 text-center text-gray-600">
                      No banners found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="Sponsor"
          title={selectedSponsor.title}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default SellerSponsored;
